/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
// eslint-disable-next-line import/no-cycle
import { List } from '@/composables/GraphQL';
// eslint-disable-next-line import/no-cycle
import { SegmentationsEditorState, State } from '@/types/store-types';
import { ActionContext } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { getThemeContactsDefinition } from '@/composables/segmentations/themes/contacts';
import { TRIGGER_SEGMENTATION_ORIGIN } from '@/composables/segmentations/triggerSegmentation';
// eslint-disable-next-line import/no-cycle
import { getThemeProductsDefinition } from '@/composables/segmentations/themes/products';
import { i18n } from '@/i18n';
// eslint-disable-next-line import/no-cycle
import {
  insertShopsListsImport,
  updateShopsListsImport,
} from '@/composables/mes-listes/ImportCustomers';

// eslint-disable-next-line import/no-cycle
import {
  OperatorType,
  ShopsListsImport,
  ShopsListsImportInputItem,
  ShopsListsImportUpdateInputItem,
} from '@/types/generated-types/graphql';

// eslint-disable-next-line import/no-cycle
import { queueState } from '@/types';

// eslint-disable-next-line import/no-cycle
import {
  listManageKey,
  myListMod,
  myListsState,
} from '@/composables/mes-listes/ListsManage';
// eslint-disable-next-line import/no-cycle
import getEventsMetadataSegments, { getAllCustomEventsMetadataSegments, getGameMetadataSegments } from '@/composables/segmentations/themes/eventsMetadata';
// eslint-disable-next-line import/no-cycle
import getVoucherSegments from '@/composables/segmentations/themes/voucher';
// eslint-disable-next-line import/no-cycle
import { getAllParentCollectionSegments } from '@/composables/segmentations/themes/collectionIteratorSegments';
// eslint-disable-next-line import/no-cycle
import { CollectionContext } from '@/composables/template-builder/collectionContext';
// eslint-disable-next-line import/no-cycle
import { AutomatedScenarioState as scenarioState } from '@/composables/AutomatedScenarios';
// eslint-disable-next-line import/no-cycle
import type { FlowStructureDto } from '@/types/flow-structure';

let translation: any;
(async () => {
  translation = await i18n;
})();

export default {
  namespaced: true,
  state: (): SegmentationsEditorState => ({
    initialized: false,
    originCall: '',
    refreshComponents: 0,
    segmentationsDefinition: {},
    configuration: [[{}]],
    errors: {
      properties: [],
      segments: [],
    },
    hasError: false,
    currentSegmentConfig: null,
    refreshContactsNumber: false,
  }),

  getters: {
    getConfiguration: (state: SegmentationsEditorState) => state.configuration,
    getRefreshComponents: (state: SegmentationsEditorState) => state.refreshComponents,
    getInitialized: (state: SegmentationsEditorState) => state.initialized,
    getGroupProperties: (state: SegmentationsEditorState) => () => (state.segmentationsDefinition.group_properties || []).reduce(
      (acc: any, group: any) => {
        if (!group.list) return acc;
        acc[group.id] = {
          label: group.label,
          rawLabel: group.rawLabel || false,
          list: group.list.map((item: any) => ({
            id: item.id,
            label: item.label,
            rawLabel: item.rawLabel || false,
            isCustomAttribute: item.isCustomAttribute || false,
            isIteration: item.isIteration || false,
            isMetadata: item.isMetadata || false,
          })),
        };
        return acc;
      },
      {},
    ),
    getPropertyDefinition: (state: SegmentationsEditorState) => (
      group: string,
      property: string,
    ) => {
      const groupDef = state.segmentationsDefinition.group_properties.find(
        (item: any) => item.id === group,
      );
      if (!groupDef) {
        return undefined;
      }
      return groupDef.list.find((item: any) => item.id === property);
    },
    getErrors: (state: SegmentationsEditorState) => state.errors,
    getCurrentSegmentConfig: (state: SegmentationsEditorState) => state.currentSegmentConfig,
    getRefreshContactsNumber: (state: SegmentationsEditorState) => state.refreshContactsNumber,
    getHasError: (state: SegmentationsEditorState) => state.hasError,
    getOriginCall: (state: SegmentationsEditorState) => state.originCall,
  },

  mutations: {
    initConfiguration: (
      state: SegmentationsEditorState,
      initialized: boolean,
    ) => {
      state.configuration = [[{}]];
      state.errors.properties = [];
      state.errors.segments = [];
      state.hasError = false;
    },
    setConfiguration: (state: SegmentationsEditorState, configuration: any) => {
      state.configuration = configuration;
      state.refreshComponents += 1;
    },
    setInitialized: (state: SegmentationsEditorState, initialized: boolean) => {
      state.initialized = initialized;
    },
    setOriginCall: (state: SegmentationsEditorState, originCall: string) => {
      state.originCall = originCall;
    },
    setSegmentationsDefinition: (
      state: SegmentationsEditorState,
      segmentationsDefinition: any,
    ) => {
      state.segmentationsDefinition = segmentationsDefinition;
    },
    addBlockAND: (state: SegmentationsEditorState) => {
      state.configuration.push([{}]);
      state.refreshComponents += 1;
    },
    addBlockOR: (state: SegmentationsEditorState, indexBlockAND: number) => {
      state.configuration[indexBlockAND].push({});
      state.refreshComponents += 1;
    },
    moveBlocksORtoBlockAND: (
      state: SegmentationsEditorState,
      payload: { indexBlockAND: number; fromIndexBlockOR: number },
    ) => {
      const { indexBlockAND, fromIndexBlockOR } = payload;

      // verify if indexBlockAND is valid
      if (
        !state.configuration[indexBlockAND]
        || fromIndexBlockOR < 0
        || fromIndexBlockOR >= state.configuration[indexBlockAND].length
      ) {
        console.error('Index invalide');
        return;
      }

      // get concerned block AND
      const blockAND = state.configuration[indexBlockAND];

      // Separating the block OR to move and the remaining block OR
      const blocksToMove = blockAND.slice(fromIndexBlockOR); // part to move

      // update the block AND, and keep only the part before the index
      state.configuration[indexBlockAND] = blockAND.slice(0, fromIndexBlockOR);

      // insert the part to move in the next block AND
      state.configuration.splice(indexBlockAND + 1, 0, blocksToMove);
      state.refreshComponents += 1;
    },
    moveBlockAndToBlockOr: (
      state: SegmentationsEditorState,
      indexBlockAND: number,
    ) => {
      // verify if indexBlockAND is valid
      if (indexBlockAND <= 0 || indexBlockAND >= state.configuration.length) {
        console.error('Index invalide');
        return;
      }

      // get concerned blocks AND
      const currentBlockAND = state.configuration[indexBlockAND];
      const previousBlockAND = state.configuration[indexBlockAND - 1];

      // add the blocks OR of the current block AND to the previous block AND
      previousBlockAND.push(...currentBlockAND);

      // remove the current block AND that is now empty
      state.configuration.splice(indexBlockAND, 1);
      state.refreshComponents += 1;
    },
    removeBlockOR: (
      state: SegmentationsEditorState,
      payload: { indexBlockAND: number; indexBlockOR: number },
    ) => {
      const { indexBlockAND, indexBlockOR } = payload;
      const blockOr = state.configuration[indexBlockAND][indexBlockOR];
      if (
        (blockOr.data !== undefined
          && blockOr.data !== null
          && blockOr.data !== '')
        || (blockOr.sub_properties
          && blockOr.sub_properties.length
          && blockOr.sub_properties[0].id)
      ) {
        state.refreshContactsNumber = true;
      }
      if (
        state.currentSegmentConfig
        && blockOr.segmentId
          === state.currentSegmentConfig.configProperty.segmentId
      ) {
        state.currentSegmentConfig = null;
      }
      if (state.currentSegmentConfig && blockOr.sub_properties) {
        const checkCurrentSegmentConfig = (properties: any[]) => {
          if (state.currentSegmentConfig) {
            properties.forEach((property) => {
              if (property.sub_properties) {
                checkCurrentSegmentConfig(property.sub_properties);
              } else if (
                property.segmentId
                === state.currentSegmentConfig.configProperty.segmentId
              ) {
                state.currentSegmentConfig = null;
              }
            });
          }
        };
        checkCurrentSegmentConfig(blockOr.sub_properties);
      }
      state.configuration[indexBlockAND].splice(indexBlockOR, 1);
      // if block AND is empty, remove it
      if (state.configuration[indexBlockAND].length === 0) {
        state.configuration.splice(indexBlockAND, 1);
      }
      state.refreshComponents += 1;
    },
    updateSegmentProperty: (
      state: SegmentationsEditorState,
      payload: { indexBlockAND: number; indexBlockOR: number; segmentData: any },
    ) => {
      const { indexBlockAND, indexBlockOR, segmentData } = payload;
      state.configuration[indexBlockAND].splice(indexBlockOR, 1, segmentData);
    },
    resetErrors: (state: SegmentationsEditorState) => {
      state.errors = {
        properties: [],
        segments: [],
      };
      state.hasError = false;
    },
    pushError: (
      state: SegmentationsEditorState,
      payload: { type: string; value: any },
    ) => {
      const { type, value } = payload;
      state.errors[type].push(value);
      state.hasError = true;
    },
    removeError: (
      state: SegmentationsEditorState,
      payload: { type: string; id: string; value: any },
    ) => {
      const { type, id, value } = payload;
      state.errors[type] = state.errors[type].filter(
        (error: any) => error[id] !== value,
      );
    },
    removePropertyError: (state: SegmentationsEditorState, payload: string) => {
      state.errors.properties = state.errors.properties.filter(
        (error: string) => error !== payload,
      );
    },
    setCurrentSegmentConfig: (
      state: SegmentationsEditorState,
      payload: any,
    ) => {
      state.currentSegmentConfig = payload;
    },
    setRefreshContactsNumber: (
      state: SegmentationsEditorState,
      payload: boolean,
    ) => {
      state.refreshContactsNumber = payload;
    },
    resetState: (state: SegmentationsEditorState) => {
      state.errors = {
        properties: [],
        segments: [],
      };
      state.hasError = false;
      state.configuration = [[{}]];
      state.currentSegmentConfig = null;
      state.refreshContactsNumber = false;
    },
  },

  actions: {
    initialization: async (
      { commit, state }: ActionContext<SegmentationsEditorState, State>,
      {
        originCall,
        configSegmentation,
        size,
        theme,
        flow,
        operatorStepId,
        collectionContexts,
      }: {
        originCall: string;
        configSegmentation: any;
        size: string;
        theme?: string | string[];
        flow?: FlowStructureDto;
        operatorStepId?: string;
        collectionContexts?: CollectionContext[];
      },
    ) => {
      commit('setInitialized', false);
      commit('resetState');
      commit('setOriginCall', originCall);

      // Normalize theme to array
      let themes: string[] = [];
      if (Array.isArray(theme)) {
        themes = theme;
      } else if (theme) {
        themes = [theme];
      }

      // Load theme definitions based on theme parameter(s)
      let themeDefinition: any[] = [];
      let themeLabel = 'segmentation.theme.contacts.title';

      // Always include contacts theme by default
      if (themes.length === 0 || themes.includes('contacts')) {
        const isTriggerSegmentation = originCall === TRIGGER_SEGMENTATION_ORIGIN;
        const includeContext = originCall === 'conditional'
          || originCall === 'workflow_filter_contact_segmentation'
          || isTriggerSegmentation;
        const contactsTheme = await getThemeContactsDefinition(
          translation.global.t,
          size,
          includeContext,
          isTriggerSegmentation,
        );
        themeDefinition = [...themeDefinition, ...contactsTheme];
      }

      // If origin is workflow_filter_contact_segmentation, check for event metadata in parent event triggers
      if (originCall === 'workflow_filter_contact_segmentation') {
        let eventsMetadataGroup = null;

        // New flow system: use flow context if provided
        if (flow && operatorStepId) {
          eventsMetadataGroup = await getEventsMetadataSegments(undefined, {
            flow,
            stepId: operatorStepId,
          });
        } else {
          // Old system: use scenarioState
          const currentOperatorId = scenarioState.selectedOperator.operatorId;
          if (currentOperatorId) {
            eventsMetadataGroup = await getEventsMetadataSegments(
              currentOperatorId,
            );
          }
        }

        if (eventsMetadataGroup) {
          themeDefinition = [...themeDefinition, eventsMetadataGroup];
        }

        // Game metadata segments — always available
        const gameSegments = getGameMetadataSegments();
        if (gameSegments) {
          themeDefinition = [...themeDefinition, gameSegments];
        }

      }

      // Add products theme if requested
      if (themes.includes('products')) {
        const includeContext = originCall === 'conditional';
        const productsTheme = await getThemeProductsDefinition(
          translation.global.t,
          includeContext,
        );
        themeDefinition = [...themeDefinition, ...productsTheme];
        themeLabel = themes.length > 1
          ? 'segmentation.theme.mixed.title'
          : 'segmentation.theme.products.title';
      }

      // Add voucher segments and custom events metadata for conditional display in template builder
      if (originCall === 'conditional') {
        const voucherSegments = getVoucherSegments();
        themeDefinition = [...themeDefinition, voucherSegments];

        // Add all custom events metadata (one group per event)
        const customEventsMetadataGroups = await getAllCustomEventsMetadataSegments();
        if (customEventsMetadataGroups.length > 0) {
          themeDefinition = [...themeDefinition, ...customEventsMetadataGroups];
        }

        // Game metadata segments — always available
        const gameSegmentsConditional = getGameMetadataSegments();
        if (gameSegmentsConditional) {
          themeDefinition = [...themeDefinition, gameSegmentsConditional];
        }

        // Add collection iterator segments (for parent loops)
        if (collectionContexts && collectionContexts.length > 0) {
          const collectionSegments = await getAllParentCollectionSegments(collectionContexts);
          if (collectionSegments.length > 0) {
            themeDefinition = [...themeDefinition, ...collectionSegments];
          }
        }
      }

      commit('setSegmentationsDefinition', {
        label: themeLabel,
        available_on: ['bulk_campaign', 'automation_campaign', 'list'],
        group_properties: themeDefinition,
      });
      commit('setConfiguration', configSegmentation);
      commit('setInitialized', true);
    },
    validate: async ({
      state,
      commit,
      getters,
    }: ActionContext<SegmentationsEditorState, State>) => {
      commit('resetErrors');
      const config = getters.getConfiguration;
      const definition = state.segmentationsDefinition;
      const validateSimpleProperty = async (
        segmentDefinition: any,
        property: any,
      ) => {
        const operators = segmentDefinition?.logical_operators;
        if (operators) {
          const operatorDefinition = Array.isArray(operators)
            ? operators.find(
              (item: any) => item.type === property.groupOperator,
            ).data[property.operator]
            : operators[property.operator];

          if (operatorDefinition?.validate) {
            const validationObject = await operatorDefinition.validate({
              [property.id]: property.data,
            });
            if (!validationObject.success) {
              commit('pushError', {
                type: 'segments',
                value: {
                  segmentId: property.segmentId,
                  value: validationObject.validate.value,
                },
              });
            }
          }
        }
      };

      const findProperty = (obj: any, path: string[]) => {
        let currentProperty: any = obj;

        for (const id of path) {
          if (!currentProperty.sub_properties) {
            return undefined;
          }

          const nextProperty = currentProperty.sub_properties.find(
            (prop: any) => prop.id === id,
          );
          if (!nextProperty) {
            return undefined;
          }

          currentProperty = nextProperty;
        }

        return currentProperty;
      };

      const processProperties = async (
        originalSegmentDefinition: any,
        properties: any,
        isSimpleProperty: boolean,
        followingPropertiesID: any = [],
      ) => {
        for (const property of properties) {
          const subProperties = property?.sub_properties;
          if (subProperties && Array.isArray(subProperties)) {
            followingPropertiesID.push(property.id);
            await processProperties(
              originalSegmentDefinition,
              subProperties,
              isSimpleProperty,
              followingPropertiesID,
            );
            followingPropertiesID.pop();
          } else {
            followingPropertiesID.push(property.id);
            const segmentDefinition = isSimpleProperty
              ? originalSegmentDefinition
              : findProperty(originalSegmentDefinition, followingPropertiesID);
            await validateSimpleProperty(segmentDefinition, property);
            followingPropertiesID.pop();
          }
        }
      };

      for (const [indexBlockAND, blockAND] of config.entries()) {
        for (const [indexBlockOR, blockOR] of blockAND.entries()) {
          if (blockOR.id) {
            const segmentGroupDefinition = definition.group_properties.find(
              (item: any) => item.id === blockOR.groupProperty,
            );
            const segmentDefinition = segmentGroupDefinition.list.find(
              (item: any) => item.id === blockOR.id,
            );
            await processProperties(
              segmentDefinition,
              blockOR.sub_properties ?? [blockOR],
              !blockOR.sub_properties,
            );
          } else {
            commit('pushError', {
              type: 'properties',
              value: `${indexBlockAND}-${indexBlockOR}`,
            });
          }
        }
      }
    },
    // TODO : delete
    save: async (
      { state, commit }: ActionContext<SegmentationsEditorState, State>,
      // eslint-disable-next-line consistent-return
      {
        idShop,
        idShopList,
        stayUpdated,
        listName,
      }: {
        idShop: number;
        idShopList: number;
        stayUpdated: boolean;
        listName: string;
      },
    ) => {
      const refreshList = () => {
        listManageKey.value += 1;
        myListMod.value.ID = idShopList;
        myListMod.value.Name = listName;
        myListMod.value.HardBounce = 0;
        myListMod.value.NonSubscribers = 0;
        myListMod.value.PercentHardBounce = '';
        myListMod.value.PercentNonSubscribers = '';
        myListMod.value.PercentSoftBounce = '';
        myListMod.value.PercentSpams = '';
        myListMod.value.PercentSubscribers = '';
        myListMod.value.PercentUnSubscribers = '';
        myListMod.value.SoftBounce = 0;
        myListMod.value.Spams = 0;
        myListMod.value.Subscribers = 0;
        myListMod.value.UnSubscribers = 0;
        myListMod.value.TotalContacts = 0;
        myListMod.value.TotalSent = 0;
        myListMod.value.TotalUniqueViews = 0;
        myListMod.value.PercentUniqueViews = '0';
        myListMod.value.TotalUniqueClicks = 0;
        myListMod.value.PercentUniqueClicks = '0%';

        myListsState.refreshComponent = idShopList;
      };

      // if (state.listImportId) {
      //   const updateInput: ShopsListsImportUpdateInputItem = {
      //     id_shop_list_import: state.listImportId,
      //     segments_config: JSON.stringify(state.configuration),
      //     stay_updated: stayUpdated,
      //     state: queueState.QUEUED,
      //   };

      //   const result = await updateShopsListsImport([updateInput]);
      //   if (result.err === '') {
      //     refreshList();
      //   }
      //   return result;
      // }
      // const inputInsert: ShopsListsImportInputItem = {
      //   id_shop: idShop,
      //   id_shop_list: idShopList,
      //   params: 'segmentationV2',
      //   file: '',
      //   segments_config: JSON.stringify(state.configuration),
      //   force_update: 1,
      //   newsletter: 1,
      //   double_optin: true,
      //   stay_updated: stayUpdated,
      //   nb_customers: 0,
      //   nb_customers_checked: 0,
      //   nb_customers_valid: 0,
      //   nb_imported_customers: 0,
      //   nb_non_imported_customers: 0,
      //   nb_partially_imported_customers: 0,
      //   path_report_folder: '',
      //   state: queueState.QUEUED,
      // };

      // const result = await insertShopsListsImport([inputInsert]);
      // if (result.err === '') {
      //   refreshList();
      // }
      // return result;
    },
  },
};
